'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Badge = require('./Badge');

var _Badge2 = _interopRequireDefault(_Badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Badge2.default;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Badge/index.js
// module id = ./node_modules/material-ui/Badge/index.js
// module chunks = index